/* eslint camelcase: ["error", {allow: ["is_locked", "default_max_distance", "default_max_weight", "default_max_volume", "default_time_window", "default_provides"]}] */
import { Grid } from '@mui/material';
import { RoutalDialog, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect } from 'react';

import { Vehicle } from '../../../domain/vehicle/Vehicle';
import { useDisableVehicles } from '../../../hooks/vehicle/useDisableVehicles';
import Button from '../../../react-components/Button';
import Text from '../../../react-components/Text';

type VehiclesDisableDialogProps = {
  open: boolean;
  selectedVehicles: Vehicle[];
  onCloseDialog: (...args: any[]) => any;
};

const VehiclesDisableDialog = ({ open, selectedVehicles, onCloseDialog }: VehiclesDisableDialogProps) => {
  const { run: disableVehicles, success, isLoading } = useDisableVehicles();

  useEffect(() => {
    if (success) {
      onCloseDialog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <RoutalDialog
      open={open}
      onCloseDialog={onCloseDialog}
      titleContent={<Text variant="h6" intlId="vehicles.disable_vehicle_dialog.title" />}
      footerContent={
        <Grid container justifyContent="flex-end">
          <Button
            disabled={isLoading}
            onClick={() => {
              if (!isLoading) disableVehicles({ vehicles: selectedVehicles });
            }}
            intlId="confirm"
          />
        </Grid>
      }
    >
      <>
        <Text intlId="vehicles.disable_vehicle_dialog.content" intlValues={{ data: selectedVehicles.length }} />

        <VSpacer medium />
      </>
    </RoutalDialog>
  );
};

export default VehiclesDisableDialog;
